import React, { FC } from 'react';
import { Container } from '@design-system/container';
import { ExtendableImage } from '@design-system/extendable-image';
import { Typography } from '@design-system/typography';
import useJoiValidation from '@root/hooks/useJoiValidation';
import useScreenRecognition from '@root/hooks/useScreenRecognition';
import { gatsbyImageMapper } from '@theme-husky/mappers/image';

import { IWaterEffectSectionProps } from './models';
import { waterEffectSectionSchema } from './WaterEffectSection.schema';

import './WaterEffectSection.scss';

const WaterEffectSection: FC<IWaterEffectSectionProps> = ({
  title,
  descriptionTop,
  descriptionBottom,
  image,
  imageAlt,
  imageBg,
  imageBgAlt,
  imageBgMobile,
  imageBgMobileAlt,
}) => {
  const {
    data,
  }: {
    data: IWaterEffectSectionProps;
  } = useJoiValidation(waterEffectSectionSchema, 'waterEffectSection', {
    title,
    descriptionTop,
    descriptionBottom,
    image,
    imageAlt,
    imageBg,
    imageBgAlt,
    imageBgMobile,
    imageBgMobileAlt,
  });
  const { isDesktop } = useScreenRecognition();

  return (
    <div className="cds-section cds-page-block water-effect-section">
      {isDesktop ? (
        <div className="water-effect-section__imageBg">
          <ExtendableImage
            element={gatsbyImageMapper({
              alt: data.imageBgAlt,
              image: data.imageBg,
              objectFit: 'cover',
            })}
          />
        </div>
      ) : (
        <div className="water-effect-section__imageMobile">
          <ExtendableImage
            element={gatsbyImageMapper({
              alt: data.imageBgMobileAlt,
              image: data.imageBgMobile,
              objectFit: 'contain',
            })}
          />
        </div>
      )}
      <Container maxWidth="full-width" className="water-effect-section__container">
        <Typography
          className="water-effect-section__title"
          tag="h2"
          variant="body"
          size="xxl"
          content={data.title}
          align="start"
          wrapping="default"
        />
        {data?.descriptionTop ? (
          <Typography
            className="water-effect-section__description-top"
            tag="p"
            variant="body"
            size="xxl"
            content={data.descriptionTop}
            align="start"
            wrapping="default"
          />
        ) : null}
        {data?.descriptionBottom ? (
          <Typography
            className="water-effect-section__description-bottom"
            tag="p"
            variant="body"
            size="xxl"
            content={data.descriptionBottom}
            align="start"
            wrapping="default"
          />
        ) : null}
        <div className="water-effect-section__image">
          <ExtendableImage
            element={gatsbyImageMapper({
              alt: data.imageAlt,
              image: data.image,
              objectFit: 'contain',
            })}
          />
        </div>
      </Container>
    </div>
  );
};
export default WaterEffectSection;
